export default "__VITE_ASSET__DL4S5tKh__"